import React, { Component } from 'react'
import { TABLA_CONSULTA_CODIGO_CUPO_PARA_ACTOR } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaConsultaCodigoCupoParaActorView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_CONSULTA_CODIGO_CUPO_PARA_ACTOR} />
    )
  }
}
